import { Box, styled } from '@mui/material';
export const PageContentGrid = styled(Box)(({ theme }) => ({
    display: 'grid',
    gap: theme.spacing(2),
    width: '100%',
    // Mobile grid
    gridTemplateColumns: '1fr 2fr',
    gridTemplateAreas: `"image summary"
  "details details"
  `,
    [theme.breakpoints.up('md')]: {
        gap: theme.spacing(6),
        // Desktop grid
        gridTemplateColumns: '314px 1fr',
        gridTemplateAreas: `"image summary"
    "image details"
    `,
    },
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFnZUNvbnRlbnRHcmlkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvcHJvZHVjdC1kZXRhaWwvY29tcG9uZW50cy9QYWdlQ29udGVudEdyaWQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBRzVDLE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBNEIsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNsRixPQUFPLEVBQUUsTUFBTTtJQUNmLEdBQUcsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztJQUNyQixLQUFLLEVBQUUsTUFBTTtJQUNiLGNBQWM7SUFDZCxtQkFBbUIsRUFBRSxTQUFTO0lBQzlCLGlCQUFpQixFQUFFOztHQUVsQjtJQUNELENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtRQUM1QixHQUFHLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7UUFDckIsZUFBZTtRQUNmLG1CQUFtQixFQUFFLFdBQVc7UUFDaEMsaUJBQWlCLEVBQUU7O0tBRWxCO0tBQ0Y7Q0FDRixDQUFDLENBQWUsQ0FBQyJ9